import {FC} from 'react';

const BillingDetail: FC = () => {
    return (
        <div>
            <h1>Billing Detail</h1>
        </div>
    );
};

export default BillingDetail;